module.exports = __webpack_public_path__ + "media/images/pre-screening-nurse-24ced1061f0e533777dc7ec96835a2e2.svg";